<template>
  <div class="h-full overflow-hidden">
    <el-scrollbar v-loading="loading" class="base-card-info h-[calc(100%-124px)] p-0 flex-1">
      <beneficiary-info ref="beneficiaryInfoRef" enable-id-type enable-enter-key class="p-6" :type="type" :data="list" @key-enter="save" />
    </el-scrollbar>

    <div class="pb-[16px]">
      <div v-if="type === 'edit'">
        <el-button @click="changeType('detail')">
          取消
        </el-button>
        <el-button type="primary" :loading="saveLoading" @click="save" @key-enter="save">
          保存
        </el-button>
      </div>
      <el-button v-else type="primary" @click="changeType('edit')">
        编辑
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type IBeneficiary, BeneficiaryInfo, queryAccountUboList, saveAccountUboList } from '@core/main';
import { scrollToErrorField } from '@core/tools';
import { ElMessage } from 'element-plus';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

defineOptions({ name: 'AgentBeneficiaryInfoTab' }); // 账户中心 - 企业管理详情 - 受益人信息

const route = useRoute();

const beneficiaryInfoRef = ref<InstanceType<typeof BeneficiaryInfo>>(null);
const type = ref<'edit' | 'detail'>('detail');
const loading = ref<boolean>(false);
const saveLoading = ref<boolean>(false);
const list = ref<IBeneficiary[]>([] as IBeneficiary[]);

const curRowId = computed(() => Number(route.query.id));

function scrollTo() {
  scrollToErrorField(beneficiaryInfoRef.value.$el);
}

async function save() {
  const { validate, getValues } = beneficiaryInfoRef.value;

  const validated = await validate();

  if (!validated) return scrollTo();
  doSubmit(getValues());
}

async function doSubmit(values: IBeneficiary[]) {
  saveLoading.value = true;
  try {
    await saveAccountUboList(false, curRowId.value, values);
    ElMessage.success('保存成功');
    saveLoading.value = false;
    type.value = 'detail';
    beneficiaryInfoRef.value?.reset();
    getDetail();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function changeType(val: 'edit' | 'detail') {
  type.value = val;

  if (type.value === 'detail') {
    beneficiaryInfoRef.value?.reset();
  }
}

async function getDetail() {
  loading.value = true;
  try {

    list.value = await queryAccountUboList(false, curRowId.value);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  loading.value = false;
}

getDetail();
</script>
